package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.fontSize
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.AnimationDirection
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.css.textDecoration
import org.lennycodes.hldi.constants.HLDITheme
val WobbleKeyframes = Keyframes {
    from { Modifier.rotate((-5).deg) }
    to { Modifier.rotate(5.deg) }
}
val DonateBtnStyle = CssStyle {
    base {
        Modifier
            .backgroundImage(
                linearGradient(
                    HLDITheme.Colors.primary,
                    HLDITheme.Colors.accent,
                    LinearGradient.Direction.ToRight
                )
            )
            . color(HLDITheme.Colors.white)
            .borderRadius(8.px)
            .textDecorationLine(TextDecorationLine.None)
            .fontWeight(600)
            .fontSize(14.px)
            .transition(
                Transition.all(
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
            .animation(
                WobbleKeyframes.toAnimation(
                    duration = 2.s,
                    iterationCount = AnimationIterationCount.Infinite,
                    timingFunction = AnimationTimingFunction.cubicBezier(0.4, 0.0, 0.2, 1.0),
                    direction = AnimationDirection.Alternate
                )
            )
    }
    hover {
        Modifier
            .backgroundColor(HLDITheme.Colors.accent)
            .color(HLDITheme.Colors.primary)
            .boxShadow(blurRadius = 10.px, spreadRadius = 16.px, color = Colors.Gray) // visual feedback
    }
}